import {Flex} from '/app/src/component';
import style from './style.css'
import React from 'react';

const AutoStyle = (selected)=>({
     marginTop: '20px',
     shrink: 0,
     border: selected ? '3px solid #2ea2d2' : '3px solid transparent',
     hoverBorder: selected ? '3px solid #2ea2d2' : '3px solid #f0f0f0',
     borderRadius: '20px',
     vAlignContent: 'center',
     padding: '28px 36px 28px 36px',
     cursor: 'pointer',
     className: style.LargeContainerStyle
})

export default ({current, index, onSelected}) => {
    const isSelected = index === current

    const Label = {
        lineHeight: '23px',
        fontSize: '24px', color: 'black',
        fontWeight: isSelected?'500':'300', basis: '15%'
    }


    return (
        <Flex  onClick={onSelected(index)} {...AutoStyle(isSelected)}>
            <Flex {...Label} > Auto </Flex>
            <Flex fontSize='18px' column grow>
                  Offlineformuläret visas när alla medarbetare är offline. När en medarbetare loggar in går chatten online igen.
            </Flex>
        </Flex>
    )
}



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/OfflineSettings/_AutoOption.js